import type { ThemeData } from '../models';

export const defaultTheme: ThemeData = {
  freeGiftProduct: {
    default: null,
  },
  collectionBanner: {
    default: {
      src: `https://cdn.shopify.com/s/files/1/1525/9812/files/desktop-sale-banner.jpg?v=1700631286`,
      height: 450,
      width: 2160,
      alt: `Pink background`,
    },
  },
  collectionBannerHideText: {
    default: false,
  },
  legalNotice: {
    default: false,
  },
  homeHeroBanner: {
    default: null,
  },
  homeHero: {
    default: {
      media: {
        mobile: {
          src: 'https://cdn.shopify.com/videos/c/o/v/8edbfd25599543229327fbbeb284faf3.mp4',
          height: 272,
          width: 414,
        },
        desktop: {
          src: 'https://cdn.shopify.com/videos/c/o/v/7cf4cf6891ab4a39b1de385b62302a4e.mp4',
          height: 640,
          width: 760,
        },
        alt: 'Shop tooth armour!',
        to: '/products/tooth-armour/',
      },
      content: {
        title: 'Tough teeth use Tooth Armour',
        description: `Supercharge your routine with the ingredients your teeth and mouth love. NEW Tooth Armour Toothpaste Serum. Order NOW`,
        button: {
          text: 'Shop now',
          to: '/products/tooth-armour/',
          width: 'full-width',
          size: 'md',
        },
      },
    },
  },
  homeSaleBanner: {
    default: {
      content: {
        title: 'Shop our bundles',
        description: 'Shop now',
        to: '/collections/bundles',
      },
      backgroundColor: 'rgb(var(--brand-pink))',
    },
  },
  homeShowcaseMode: {
    default: 'media',
  },
  homeShowcaseOptions: {
    default: {
      mobile: {
        contentAlign: 'left',
        contentPadding: '2rem',
        contentPosition: 'top-left',
        textColor: 'dark',
        titleFontSize: '2rem',
        descriptionFontSize: '1rem',
        descriptionColor: '#030303',
        aspectRatio: '131 / 235',
        maxContentWidth: '27rem',
        buttonMaxWidth: '20rem',
      },
      desktop: {
        contentAlign: 'left',
        contentPadding: '0 0 0 2.5rem',
        contentPosition: 'top-left',
        textColor: 'dark',
        buttonMaxWidth: '10rem',
        titleFontSize: '2.25rem',
        descriptionFontSize: '1rem',
        descriptionColor: '#030303',
        maxContentWidth: '27rem',
      },
    },
  },
  homeShowcaseContent: {
    default: {
      content: {
        title: 'Your everyday whitening routine, sorted.',
        description: 'An easy way to stay consistent with<br>whitening at home.',
        afterContent: {
          button: {
            to: '/products/affordable-whitening-set',
            text: 'Shop now',
            variant: 'primary',
          },
        },
      },
      background: {
        media: {
          mobile: {
            src: 'https://cdn.shopify.com/s/files/1/0916/4078/files/Page_Feature_-_Affordable_Whitening_Set_AWS_-_D.png?v=1779764471',
            height: 1024,
            width: 570,
          },
          desktop: {
            src: 'https://cdn.shopify.com/s/files/1/0916/4078/files/Page_Feature_-_Affordable_Whitening_Set_AWS_-_D.png?v=1779764471',
            height: 668,
            width: 1365,
          },
          alt: 'Flavoured toothpaste bundle 3 pack',
        },
      },
    },
  },
  homeShowcaseMedia: {
    default: {
      mobile: {
        src: 'https://cdn.shopify.com/s/files/1/2502/5300/files/AWSM.png?v=1779766010',
        height: 1024,
        width: 570,
      },
      desktop: {
        src: 'https://cdn.shopify.com/s/files/1/2502/5300/files/AWSD.png?v=1779766011',
        height: 668,
        width: 1365,
      },
    },
    ca: {
      mobile: {
        src: 'https://cdn.shopify.com/s/files/1/2502/5300/files/Page_Feature_-_V34_text_-_CA_-_M.png?v=1778537641',
        height: 1024,
        width: 570,
      },
      desktop: {
        src: 'https://cdn.shopify.com/s/files/1/2502/5300/files/Page_Feature_-_V34_text_-_CA_-_D.png?v=1778537642',
        height: 668,
        width: 1365,
      },
    },
  },
  homeShowcaseMediaLink: {
    default: {
      to: `/products/affordable-whitening-set`,
    },
    ca: {
      to: `/products/v34-whitening-strips`,
    },
  },
  navImageBlocks: {
    default: {
      imageBlocks: [
        {
          title: 'iD Stain Whitening Mouthwash',
          link: '/products/id-stain-mouthwash/',
          details: {
            src: 'https://cdn.shopify.com/s/files/1/0916/4078/files/Nav_-_Starter_Bundle_V2-_M.png?v=1784864971',
            alt: 'iD Stain Whitening Mouthwash',
            height: 240,
            width: 366,
          },
        },
        {
          title: 'Tooth Armour',
          link: '/products/tooth-armour',
          details: {
            src: 'https://cdn.shopify.com/s/files/1/2502/5300/files/Nav_-_Tooth_Armour.png?v=1774928763',
            alt: 'Tooth Armour',
            height: 240,
            width: 366,
          },
        },
      ],
    },
    ca: {
      imageBlocks: [
        {
          title: 'Shop Electric Toothbrush',
          link: '/products/electric-toothbrush/',
          details: {
            src: 'https://cdn.shopify.com/s/files/1/0916/4078/files/Nav_-_Electric_Toothbrush.jpg?v=1706071329',
            alt: 'Electric Toothbrush in Pink, Purple and Green',
            height: 240,
            width: 366,
          },
        },
        {
          title: 'Tooth Armour',
          link: '/products/tooth-armour',
          details: {
            src: 'https://cdn.shopify.com/s/files/1/2502/5300/files/Nav_-_Tooth_Armour.png?v=1774928763',
            alt: 'Tooth Armour',
            height: 240,
            width: 366,
          },
        },
      ],
    },
  },
  marqueeData: {
    default: {
      text: `New Tooth Armour Toothpaste Serum. Order NOW`,
      to: `/products/tooth-armour`,
    },
  },
  delayedShippingMessages: {
    default: [],
  },
  globalProductPill: {
    default: null,
  },
  globalProductCardBadge: {
    default: null,
  },
  globalProductImageBadge: {
    default: null,
  },
};
